export enum TrackingEvents {
  // Payment Events
  ADYEN_ACTION_HANDLED = 'adyen_action_handled',
  ADYEN_PAYMENT_COMPLETED = 'adyen_payment_completed',
  INTERNATIONAL_CONTINUE_TO_PAYMENT_CLICKED = 'International continue to payment clicked',
  RECAPTCHA_TOKEN_GENERATION_FAILED = 'reCAPTCHA token generation failed',

  // Gift Card & Discounts
  CLICKED_APPLY_GIFT_CARD = 'Clicked apply gift card',
  GIFT_CARD_APPLIED_SUCCESSFULLY = 'Gift card applied successfully',
  GIFT_CARD_ERROR = 'Gift card error',
  GIFT_CARD_PURCHASED = 'Gift card purchased',

  // Authentication Events
  CLICKED_SEND_CODE = 'Clicked Send code',
  COMPLETED_2FA = 'Completed 2FA',
  EXITED_2FA_FLOW_EARLY = 'Exited 2FA flow early',
  STARTED_AUTHENTICATION = 'Started Authentication',

  // Delivery & Location Events
  DELIVERY_ADDRESS_VALIDATION_ERROR = 'Delivery Address Validation Error',
  DINING_OPTION_CHANGED_V2 = 'Dining Option Changed v2',
  ENTERED_DELIVERY_ADDRESS = 'entered_delivery_address',
  ADDRESS_SEARCH_COMPONENT_ERROR = 'Address Missing Required Fields',
  MANUAL_ADDRESS_BUTTON_CLICKED = 'Manual Address Button Clicked',
  ENTERED_MANUAL_DELIVERY_ADDRESS = 'Entered Manual Delivery Address',
  MANUAL_ADDRESS_LOCATION_MATCH_ERROR = 'Manual Address Location Match Error',
  REDIRECTED_TO_MANUAL_ADDRESS = 'Partial Address Redirected To Manual',
  DINING_BEHAVIOR_SUMMARY_CLICKED = 'Dining Behavior Summary Clicked',
  FULFILLMENT_TIME_SUMMARY_CLICKED = 'Fulfillment Time Summary Clicked',
  VALID_DELIVERY_ADDRESS_ENTERED = 'valid_delivery_address_entered',
  LOCATION_SELECTION_PAGE_LOCATION_PICKER = 'Location picker page view',

  // Order Events
  ORDER_PLACEMENT_FAILED = 'Order Placement Failed',
  ORDER_PLACED = 'Order placed',
  ORDER_SUCCESS_SCREEN_VIEWED = 'Order Success Screen Viewed',
  PLACE_ORDER_CLICKED = 'Place Order clicked',
  REVIEW_ORDER_SCREEN_VIEWED = 'Review order screen viewed',
  PLACED_ORDER_AFTER_REVIEW = 'Placed order after review',
  GO_BACK_CLICKED = 'Go back clicked',
  TIMER_RESET = 'Order review timer reset',
  UNKNOWN_CHECKOUT_ERROR_TYPE = 'Unknown checkout error type',
  ADDED_ITEM_TO_CART = 'Added item to cart',
  EDITED_ITEM_IN_CART = 'Edited item in cart',
  CART_IN_NAVIGATION_CLICK = 'cart_in_navigation_click',
  DOWNLOAD_RECEIPT_PDF_BUTTON_CLICK = 'Download Receipt PDF button click',

  // Reservation Events
  RESERVATION_PLACED = 'Reservation placed',

  // Order Tracking & Support
  CLICKED_TDS_DRIVER_CONTACT = 'TDS Driver Contact Clicked',
  CLICKED_TDS_RX_CONTACT = 'TDS Rx Contact Clicked',
  // A guest owed a refund could not be handed to support: the signed session the
  // Intercom refund workflow requires was unavailable. Silent otherwise — the card
  // has no visible error state to detect this from.
  TDS_REFUND_SUPPORT_UNAVAILABLE = 'TDS Refund Support Unavailable',
  // The two terminal recovery exceptions. The payloads carry iOS's own exception ids so both
  // platforms' funnels line up — web's equivalent of iOS's `order_support_exception_*` events.
  TDS_REFUND_EXCEPTION_VIEWED = 'TDS Refund Exception Viewed',
  TDS_REFUND_EXCEPTION_ACTION = 'TDS Refund Exception Action Tapped',

  // Loyalty & Rewards
  LOYALTY_REWARD_TAPPED = 'Loyalty Reward Tapped',
  LOYALTY_SIGNUP = 'Loyalty signup',

  // Marketing
  SMS_MARKETING_SIGNUP = 'SMS marketing signup',
  EMAIL_MARKETING_SIGNUP = 'Email marketing signup',
  SMS_MARKETING_UNSUBSCRIBE = 'SMS marketing unsubscribe',
  EMAIL_MARKETING_UNSUBSCRIBE = 'Email marketing unsubscribe',

  // Offers
  OFFER_APPLIED = 'Offer applied',
  FREE_DELIVERY_OFFER_LOGIN_COMPLETED = 'Free delivery offer login completed',

  // Toast Local App
  TOAST_LOCAL_APP_CTA_CLICKED = 'Toast Local app CTA clicked',

  // Search & Navigation
  MENU_SEARCH_INITIATED = 'Menu search initiated',
  MENU_SEARCH_QUERY_COMPLETE = 'Menu search query complete',

  // Filter & Sort
  MENU_FILTER_CHANGED = 'Menu filter changed',
  MENU_SORT_CHANGED = 'Menu sort changed',

  // Page Views
  CHECKOUT_PAGE_VIEW = 'Checkout page view',
  ECOMM_CHECKOUT_PAGE_VIEW = 'Ecomm Checkout page view',
  LOCAL_HOME_VIEW = 'Local home view',
  LOCAL_SEARCH_VIEW = 'Local search view',
  ORDER_PAGE_VIEW = 'Order page view',
  PRODUCT_DISPLAY_PAGE_VIEW = 'Product Display page view',
  ACCOUNT_PAGE_VIEW = 'Account page view',
  CONFIRMATION_PAGE_VIEW = 'Confirmation page view',

  // Location Actions
  CHANGE_LOCATION_BUTTON_CLICKED = 'Change Location Button Clicked',
  LOCATION_CHANGE_CONFIRMED = 'Location Change Confirmed',
  LOCATION_SELECTION_GATE_CONFIRMED = 'Location Selection Gate Confirmed',
  LOCATION_SELECTION_GATE_SHOWN = 'Location Selection Gate Shown',
  GOOGLE_MAPS_LINK_CLICKED = 'Google Maps link clicked',
  EMBEDDED_GOOGLE_MAPS_CLICKED = 'Embedded Google Maps clicked',
  PHONE_NUMBER_CLICKED = 'Phone number clicked',
  STORE_HOURS_CLICKED = 'Store hours clicked',

  // Action Banners
  ACTION_BANNER_ADMIN = 'action_banner_admin',
  ACTION_BANNER_CLICKED = 'action_banner_clicked',
  ACTION_BANNER_VIEWED = 'action_banner_viewed',

  // Guest Analytics
  PAGE_VIEW = 'Page view',
  SESSION_START = 'Session start',

  // Error Pages
  OO_FALLBACK_500_VIEW = 'OO 500 Fallback view',
  SITES_FALLBACK_500_VIEW = 'Sites 500 Fallback view',

  // Customer Actions
  PASSWORDLESS_LOGIN_SUCCESS = 'passwordlessLogin_success',
  PASSWORDLESS_LOGIN_ERROR = 'passwordlessLogin_error',
  PWLESS_LOGOUT_SUCCESS = 'pwlessLogout_success',
  PWLESS_LOGOUT_ERROR = 'pwlessLogout_error',
  COMPLETE_SIGNUP_SUCCESS = 'completeSignup_success',
  COMPLETE_SIGNUP_ERROR = 'completeSignup_error',
  REFETCH_CUSTOMER_SUCCESS = 'refetchCustomer_success',
  REFETCH_CUSTOMER_ERROR = 'refetchCustomer_error',
  FETCH_CUSTOMER_SUCCESS = 'fetchCustomer_success',
  FETCH_CUSTOMER_ERROR = 'fetchCustomer_error',
  REFRESH_AUTH_TOKEN_SUCCESS = 'refreshAuthToken_success',
  REFRESH_AUTH_TOKEN_ERROR = 'refreshAuthToken_error',

  // Menu Item Events
  CLICKED_MENU_ITEM = 'Clicked menu item',

  // QR Code Landing Modal
  QR_LANDING_MODAL_VIEWED = 'QR Landing Modal Viewed',

  // Alert Modal
  ALERT_MODAL_VIEWED = 'Alert Modal Viewed'
}

export const FULFILLMENT_EVENTS = new Set<TrackingEvents>([
  TrackingEvents.ORDER_PLACED,
  TrackingEvents.RESERVATION_PLACED,
  TrackingEvents.GIFT_CARD_PURCHASED
])

export const CONSENT_EXEMPT_EVENTS = new Set<TrackingEvents>([
  TrackingEvents.ORDER_PLACED,
  TrackingEvents.RESERVATION_PLACED,
  TrackingEvents.GIFT_CARD_PURCHASED,
  TrackingEvents.LOYALTY_SIGNUP,
  TrackingEvents.SMS_MARKETING_SIGNUP,
  TrackingEvents.EMAIL_MARKETING_SIGNUP,
  TrackingEvents.OFFER_APPLIED,
  TrackingEvents.SESSION_START
])

export const TRACKER_EVENT_FILTERS: Partial<
  Record<string, Set<TrackingEvents>>
> = {
  guestAnalytics: new Set([
    // Session & Page View Events
    TrackingEvents.PAGE_VIEW,
    TrackingEvents.SESSION_START,

    // Fulfillment Events
    TrackingEvents.ORDER_PLACED,
    TrackingEvents.RESERVATION_PLACED,
    TrackingEvents.GIFT_CARD_PURCHASED,

    // Signup & Marketing Events
    TrackingEvents.LOYALTY_SIGNUP,
    TrackingEvents.SMS_MARKETING_SIGNUP,
    TrackingEvents.EMAIL_MARKETING_SIGNUP,

    // Engagement Events
    TrackingEvents.OFFER_APPLIED,
    TrackingEvents.GOOGLE_MAPS_LINK_CLICKED,
    TrackingEvents.EMBEDDED_GOOGLE_MAPS_CLICKED,
    TrackingEvents.PHONE_NUMBER_CLICKED,
    TrackingEvents.STORE_HOURS_CLICKED
  ])
  // Can be extended to filter events for other trackers in the future
}
